import { useAppSelector } from "../../../store";
import { isUrlIncludesRoutes } from "../../../common/util/routeUtils";
import { Footer } from "../../Footer/Footer";

export interface SiteFooterProps {
  shouldDisplay: boolean;
}

export const SiteFooter = () => {
  const { footless } = useAppSelector((state) => state.loginLocalStorage);

  return !isUrlIncludesRoutes("auth") && footless === false ? (
    <div className="App__footer">
      <Footer />
    </div>
  ) : (
    <></>
  );
};
